<script setup lang="ts">
import QrCodeView from "@/scripts/components/app/qrcodes/form/QrCodeView.vue";
import {Dialog, DialogOverlay, TransitionChild, TransitionRoot} from "@headlessui/vue";

import {defineEmits, defineProps} from "vue";
import VDownloadCodeButton from "@/scripts/components/app/qrcodes/form/VDownloadCodeButton.vue";
import VButton from "@/scripts/components/app/common/VButton.vue";

const props = defineProps({
    isOpen: Boolean,
    identifier: String,
});

const emit = defineEmits(["modal-close"]);

const redirectToNewForm = () => {
    window.location.href = '/qrcodes/create';
}

</script>

<template>
    <TransitionRoot as="template" :show="props.isOpen">
        <Dialog as="div" class="fixed z-50 inset-0 overflow-y-auto" @close="emit('modal-close')">
            <div class="flex sm:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-8/12 sm:p-6">
                        <div class="font-bold mb-8 text-center text-xl">
                            QR Код сохранен
                        </div>
                        <qr-code-view class="w-20 sm:w-32"> </qr-code-view>
                        <div class="justify-center mt-4 flex">
                            <v-download-code-button :identifier="props.identifier" class="mr-2"></v-download-code-button>
                            <v-button title="Создать новый" @click="redirectToNewForm"></v-button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<style scoped>

</style>